export enum CacheType {
  USER_INFO
}

export interface CacheInfo {
  /** 数据 */
  data: any;
  /** 过期时间 */
  expire: number;
}
